import { restaurant } from "../mock";

export async function sendOwnerEmail({ subject, replyTo, fields, honey, autoresponse }) {
  if (honey) return {};

  const to = restaurant.email;
  const res = await fetch(`https://formsubmit.co/ajax/${encodeURIComponent(to)}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      _subject: subject,
      _template: "table",
      _captcha: "false",
      _honey: "",
      ...(replyTo ? { _replyto: replyTo } : {}),
      ...(autoresponse ? { _autoresponse: autoresponse } : {}),
      ...fields,
    }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Email send failed (${res.status})`);
  }

  const data = await res.json().catch(() => ({}));
  if (data.success === "false" || data.success === false) {
    throw new Error(data.message || "Email send failed");
  }
  return data;
}